var _metadata, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphQl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 2380.8494,
    viewBox: "20.8 4.2 348.52013 372.93624",
    width: 2118.9324,
    id: "svg20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata26"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    style: {
      fill: "#e535ab"
    },
    transform: "translate(-4.9399331,-9.7988986)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 57.468,302.66 -14.376,-8.3 160.15,-277.38 14.376,8.3 z",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 39.8,272.2 h 320.3 v 16.6 H 39.8 Z",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 206.348,374.026 -160.21,-92.5 8.3,-14.376 160.21,92.5 z m 139.174,-241.079 -160.21,-92.5 8.3,-14.376 160.21,92.5 z",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 54.482,132.883 -8.3,-14.375 160.21,-92.5 8.3,14.375 z",
    id: "path8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 342.568,302.663 -160.15,-277.38 14.376,-8.3 160.15,277.38 z M 52.5,107.5 h 16.6 v 185 H 52.5 Z",
    id: "path10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 330.9,107.5 h 16.6 v 185 h -16.6 z",
    id: "path12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 203.522,367 -7.25,-12.558 139.34,-80.45 7.25,12.557 z",
    id: "path14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 369.5,297.9 c -9.6,16.7 -31,22.4 -47.7,12.8 -16.7,-9.6 -22.4,-31 -12.8,-47.7 9.6,-16.7 31,-22.4 47.7,-12.8 16.8,9.7 22.5,31 12.8,47.7 M 90.9,137 c -9.6,16.7 -31,22.4 -47.7,12.8 -16.7,-9.6 -22.4,-31 -12.8,-47.7 9.6,-16.7 31,-22.4 47.7,-12.8 16.7,9.7 22.4,31 12.8,47.7 M 30.5,297.9 c -9.6,-16.7 -3.9,-38 12.8,-47.7 16.7,-9.6 38,-3.9 47.7,12.8 9.6,16.7 3.9,38 -12.8,47.7 -16.8,9.6 -38.1,3.9 -47.7,-12.8 M 309.1,137 c -9.6,-16.7 -3.9,-38 12.8,-47.7 16.7,-9.6 38,-3.9 47.7,12.8 9.6,16.7 3.9,38 -12.8,47.7 -16.7,9.6 -38.1,3.9 -47.7,-12.8 M 200,395.8 c -19.3,0 -34.9,-15.6 -34.9,-34.9 0,-19.3 15.6,-34.9 34.9,-34.9 19.3,0 34.9,15.6 34.9,34.9 0,19.2 -15.6,34.9 -34.9,34.9 M 200,74 c -19.3,0 -34.9,-15.6 -34.9,-34.9 0,-19.3 15.6,-34.9 34.9,-34.9 19.3,0 34.9,15.6 34.9,34.9 0,19.3 -15.6,34.9 -34.9,34.9",
    id: "path16"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphQl);
export default __webpack_public_path__ + "static/media/GraphQL.040a4dbe04d01ce1627cdf8574caf8a3.svg";
export { ForwardRef as ReactComponent };